export const pages = {
	home: '/home',
	notFound: '/404',
	post_signout: '/signed_out',
	change_password: '/change_password',
	services: '/services',
	broadband: '/services/broadband',
	broadbandList: '/services/broadband_services',
	TvAndSecurity: '/services/tv_and_security',
	emailService: '/services/email_management'
};
